import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import {
  HISTORY_ICON,
  ICON_DIMENSION,
  defaultContext,
  getInitialStyle,
  getFocusedStyle,
  getUnFocusedStyle,
} from './searchedItem.style';
import Icon from '../../tornado/icon/icon.component';

export default class SearchedItem extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Icon: {
          type: Icon,
        },
        Title: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  set data(item) {
    this.patch({
      Icon: {
        iconData: {
          picto: HISTORY_ICON,
          viewBox: {
            w: ICON_DIMENSION[this._style.screenSize].w,
            h: ICON_DIMENSION[this._style.screenSize].h,
          },
        },
      },
      Title: {
        text: {
          text: item,
        },
      },
    });
  }

  _focus() {
    this.patch(getFocusedStyle(this._style));
  }

  _unfocus() {
    this.patch(getUnFocusedStyle(this._style));
  }
}
